export type WorkspaceRole = 'OWNER' | 'ADMIN' | 'MEMBER';

export function canManageFinance(role: WorkspaceRole): boolean {
  return role === 'OWNER' || role === 'ADMIN';
}

